// About Page
export function aboutPage() {
  return `
<div class="min-h-screen bg-gray-50">
    <div class="hero min-h-[40vh] flex items-center bg-cover bg-center bg-fixed" 
         style="background-image: linear-gradient(135deg, rgba(63, 137, 233, 0.85), rgba(121, 211, 238, 0.75)), url('/images/header1.webp')">
        <div class="hero-content">
            <h1 class="hero-title">CEE Casas España</h1>
            <p class="hero-subtitle">
                CEEcasasespaña.com es una iniciativa de asesores energéticos con más de 15 años de experiencia conjunta en el mercado de certificados energéticos.
            </p>
        </div>
    </div>

    <section class="section bg-gray-50">
        <div class="container">
            <div class="max-w-4xl mx-auto prose prose-lg">
                <div class="bg-white p-8 rounded-lg shadow-sm">
                    <h2 class="text-2xl text-blue-900 mb-4">Sobre nosotros</h2>

                    <div class="space-y-6 text-gray-700">
                        <p>
                            CEEcasasespaña.com es una iniciativa de asesores con más de 15 años de experiencia conjunta en el mercado de certificados energéticos. En CEEcasasespaña.com estamos listos para ayudarte a obtener tu certificado energético de forma rápida y sencilla. Compara todos los asesores disponibles y encuentra la empresa que mejor se adapte a ti.
                        </p>

                        <h2 class="text-2xl text-blue-900 mb-4">Sobre CEEcasasespaña.com</h2>
                        <p>
                            Como propietario de un inmueble, necesitas un nuevo certificado energético aproximadamente una vez cada ocho años. Es lógico que no estés familiarizado con este mercado. Aun así, quieres un buen producto y un servicio agradable a un precio justo. Nosotros te lo ponemos fácil mostrando de manera clara todos los asesores certificados cerca de ti. Incluso lo hacemos más sencillo recopilando toda la información sobre certificados energéticos en un solo lugar. Así encontrarás rápidamente al asesor que mejor se adapte a tus necesidades.
                        </p>
                        <a href="/about/" class="btn bg-green-500 text-white px-6 py-3 rounded-lg font-medium inline-block">
                            Leer más sobre CEEcasasespaña.com
                        </a>

                        <h2 class="text-2xl text-blue-900 mb-4">Por qué CEEcasasespaña.com</h2>
                        <p>
                            Necesitas un certificado energético para tu vivienda o local comercial. Buscas rapidez y flexibilidad. Quieres que todo esté bien organizado, sin complicaciones, con una sonrisa y a un precio competitivo. ¡Esa es exactamente la razón por la que la gente elige CEEcasasespaña.com! Comparamos todos los asesores energéticos y te ayudamos a encontrar el que mejor se adapta a ti. Nos dedicamos a hacer fáciles las cosas difíciles. Por eso nuestros clientes nos valoran con una media de 4,9 sobre 5 estrellas. Estamos orgullosos de ello y nos motiva a ofrecerte el mejor servicio.
                        </p>
                        <a href="/about/" class="btn bg-green-500 text-white px-6 py-3 rounded-lg font-medium inline-block">
                            Leer más sobre por qué CEEcasasespaña.com
                        </a>

                        <h2 class="text-2xl text-blue-900 mb-4">Todos los asesores energéticos</h2>
                        <p>
                            En CEEcasasespaña.com tienes asesores energéticos disponibles en toda España. Ofrecemos la comparación más completa de asesores certificados del país. Además, todos los asesores que mostramos están titulados y debidamente certificados.
                        </p>
                        <a href="/cadastro/" class="btn bg-green-500 text-white px-6 py-3 rounded-lg font-medium inline-block">
                            Ver todos los asesores energéticos
                        </a>

                        <h2 class="text-2xl text-blue-900 mb-4">Todos los partners</h2>
                        <p>
                            En CEEcasasespaña.com colaboramos con varias entidades del sector. Nuestro objetivo es apoyar a las empresas afiliadas en su trabajo y ayudar a nuevos profesionales a entrar en el mercado. Nos encanta redirigirte a nuestros socios de confianza.
                        </p>
                        <a href="/advisors/" class="btn bg-green-500 text-white px-6 py-3 rounded-lg font-medium inline-block">
                            Ver todos los partners
                        </a>

                        <h2 class="text-2xl text-blue-900 mb-4">Nuestro equipo</h2>
                        <p>
                            ¡Conoce al equipo de CEEcasasespaña.com! Estamos aquí para ayudarte a obtener tu certificado energético de forma rápida y sencilla. Somos expertos en conectar a los propietarios de inmuebles con las empresas certificadas que forman parte de CEEcasasespaña.com.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <!-- Team section with minimal distance -->
    <section class="section bg-gray-50 mt-0 pt-0">
        <div class="container">
            <div class="max-w-4xl mx-auto prose prose-lg">
                <div class="bg-white p-8 rounded-lg shadow-sm">
                    <div class="grid grid-cols-1 sm:grid-cols-4 gap-4 items-start">
                        <div class="flex flex-col items-center">
                            <img src="/images/team/Marinus-Over-Ons-EPCSpainHomes.webp" alt="Marinus- EPCSpainHomes team" class="w-48 h-auto rounded-md shadow-md" />
                            <p class="mt-4 text-gray-600 text-center text-sm">Marinus — info@ceecasasespana.com</p>
                        </div>
                        <div class="flex flex-col items-center">
                            <img src="/images/team/Vincent-Over-Ons-EPCSpainHomes.webp" alt="Vincent - EPCSpainHomes team" class="w-48 h-auto rounded-md shadow-md" />
                            <p class="mt-4 text-gray-600 text-center text-sm">Vincent — info@ceecasasespana.com</p>
                        </div>
                                                <div class="flex flex-col items-center">
                            <img src="/images/team/Filip-Over-Ons-EPCSpainHomes.webp" alt="Filip - EPCSpainHomes team" class="w-48 h-auto rounded-md shadow-md" />
                            <p class="mt-4 text-gray-600 text-center text-sm">Filip — info@ceecasasespana.com</p>
                        </div>
                        <div class="flex flex-col items-center">
                            <img src="/images/team/Mark-Over-Ons-EPCSpainHomes.webp" alt="Mark - EPCSpainHomes team" class="w-48 h-auto rounded-md shadow-md" />
                            <p class="mt-4 text-gray-600 text-center text-sm">Mark — info@ceecasasespana.com</p>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </section>
</div>


    `;
}
